import { inject, Injectable } from '@angular/core';

import { FilterService } from 'app/modules/collection/services/filter.service';
import { ComparisonHandlerService } from 'app/modules/dashboard/services/comparison-handler-service';
import { NewspaperService } from 'app/providers/storage-api/newspaper.service';
import { Widget } from '../../../../../providers/bridge-api/dashboard.service';
import { WidgetChartOptions } from '../../widget-chart/widget-chart.component';
import NumericMetadataOverTimeJournalist from './numeric-metadata-over-time-journalist';

@Injectable({ providedIn: 'root' })
export class EmploymentCenter {
  private comparisonService = inject(ComparisonHandlerService);
  private newspaperService = inject(NewspaperService);
  private filterService = inject(FilterService);

  createJournalist(widget: Widget<WidgetChartOptions>) {
    switch (widget.payload.type) {
      case 'numericMetadata':
        return new NumericMetadataOverTimeJournalist(
          widget,
          this.comparisonService,
          this.newspaperService,
          this.filterService
        );
    }
  }
}
